"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionnaireTypes = void 0;
var QuestionnaireTypes;
(function (QuestionnaireTypes) {
    QuestionnaireTypes["CONDITION"] = "valuation";
    QuestionnaireTypes["OPTIONAL_EXTRAS"] = "optional_extras";
    QuestionnaireTypes["NEXT_ACTIONS"] = "next_steps";
    QuestionnaireTypes["DETAILS"] = "vehicle_details";
    QuestionnaireTypes["HISTORY"] = "vehicle_history";
    QuestionnaireTypes["FINANCE"] = "finance";
    QuestionnaireTypes["FACTORY_FITTED_OPTIONS"] = "factory_fitted_options";
})(QuestionnaireTypes = exports.QuestionnaireTypes || (exports.QuestionnaireTypes = {}));
